import adminApiClient from '../api/adminApiClient'
import type { DashboardSummary, TimelinePoint, AiPerformance, BranchStatRow } from '../types'

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const { data } = await adminApiClient.get<DashboardSummary>('/dashboard/summary')
  return data
}

export async function getOrdersTimeline(params: {
  from?: string
  to?: string
  granularity?: 'day' | 'week' | 'month'
}): Promise<TimelinePoint[]> {
  const { data } = await adminApiClient.get<TimelinePoint[]>('/dashboard/orders/timeline', { params })
  return data
}

export async function getAiPerformance(): Promise<AiPerformance> {
  const { data } = await adminApiClient.get<AiPerformance>('/dashboard/ai/performance')
  return data
}

export async function getBranchesStats(): Promise<BranchStatRow[]> {
  const { data } = await adminApiClient.get<BranchStatRow[]>('/dashboard/branches/stats')
  return data
}
